module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAANVJREFUSEu91C2SAjEQxfH/q0IgEEiOgOMAXGUPgOQAiEUgkEg0tWovgMMguMWKPchbUoWYouajewY2Ovkl6by0eNPQm1z+H7Y9Br6Bq6R99maNJ7Y9AX6B6R39lLTN4K2lsL0AzsAsi3fW2PYcuGTxTrhcvw8egvvgYTiLp+AafCXpWJeWPvDykZQSxw9JX4Nh21V0LenQlO3wiTNo2SwEZ9EQ/IRuJO0iX7vrS1drmuoXbU2oNJ+flzch2yPgBNzaXn9wKiJ1rc4JpSKLhlLRBy1r/gCHbFAXQWN2MAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/serviceImg/service/Frame@2x (2).png
// module id = AMmW
// module chunks = 64